import { DetailedHTMLProps, SelectHTMLAttributes } from "react";
import Select, { components } from "react-select";

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <div className="z-40 flex items-center space-x-2">
        <input
          className="flex items-center space-x-2 hover:bg-white"
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />

        <label>{props.label}</label>
      </div>
    </components.Option>
  );
};

const customStyles = {
  multiValueRemove: (provided: any) => ({
    ...provided,
    display: "none",
  }),

  multiValue: (provided: any) => ({
    ...provided,
    textOverflow: "ellipsis",
    maxWidth: "70%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
    backgroundColor: "transparent",
    padding: "0",
  }),

  option: (provided: any) => ({
    ...provided,
    active: "",
    padding: "3px",
    color: "black",
    backgroundColor: "white",
    fontSize: "12px",
  }),

  control: (provided: any) => ({
    ...provided,
    background: "#fff",
    border: "0",
    minHeight: "26px",
    height: "26px",
    boxShadow: null,
  }),

  valueContainer: (provided: any) => ({
    ...provided,
    height: "26px",
    padding: "0px 6px",
  }),

  input: (provided: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: "28px",
    margin: "0px",
  }),

  menu: (provided: any) => ({
    ...provided,
    overflowX: "auto",
    paddingLeft: "10px",
    height: "max",
  }),
};

const ValueContainer = ({ children, ...props }: any) => {
  const [values, input] = children;

  let displayedValues = values;

  if (Array.isArray(values)) {
    if (values.length > 1) {
      if (values.length === props.options.length) {
        displayedValues = "ALL";
      } else {
        displayedValues = `Selected (${values.length}) `;
      }
    }
  } else if (!input.props?.value?.length) {
    displayedValues = "Select multiple options...";
  }

  return (
    <components.ValueContainer {...props}>
      {displayedValues}
      {input}
    </components.ValueContainer>
  );
};

interface ISelectHookFormMulti extends DetailedHTMLProps<
  SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
> {
  field?: any;
  options: any[];
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
  label?: string;
  validation?: any;
  isMulti?: boolean;
  onChange?: any;
  value?: any;
  isLoading?: boolean;
  secondDiv?: string;
  inputId?: string;
  placeholder?: string;
}

const SelectHookFormMulti: React.FC<ISelectHookFormMulti> = ({
  field,
  options,
  isDisabled,
  className,
  label,
  onChange,
  value = [],
  isMulti = true,
  isLoading,
  secondDiv = "md:grid-cols-3 items-center",
  isRequired,
  inputId,
  placeholder,
}) => {
  let selectedValue = value ?? null;

  if (isMulti) {
    const hasAllOption =
      Array.isArray(value) &&
      value.find(
        (item: { value: any }) =>
          typeof item.value === "string" && item.value.toUpperCase() === "ALL",
      );

    if (hasAllOption) {
      selectedValue = options;
    } else {
      selectedValue = value;
    }
  }

  const selectComponents = isMulti
    ? {
        ValueContainer,
        Option,
      }
    : undefined;

  return (
    <div className="w-full space-y-1 text-xs">
      <div className={`grid ${secondDiv} w-full items-start`}>
        {label && (
          <label className="expandedLabel fontExpand flex items-stretch text-left">
            {isRequired && (
              <span className="self-start font-bold text-red-500">*</span>
            )}
            {label}:
          </label>
        )}

        <Select
          className={`${
            className || "col-span-2 border border-gray-300"
          } rounded-sm text-xs focus:border-quaternary focus:ring-quaternary ${
            isDisabled ? "opacity-20" : ""
          }`}
          {...field}
          inputId={inputId}
          onChange={onChange}
          value={selectedValue}
          options={options}
          isMulti={isMulti}
          isSearchable
          isClearable
          closeMenuOnSelect={!isMulti}
          hideSelectedOptions={!isMulti}
          styles={customStyles}
          isDisabled={isDisabled}
          components={selectComponents}
          tabSelectsValue={false}
          isLoading={isLoading}
          placeholder={
            placeholder ??
            (isMulti ? "Select multiple options..." : "Select...")
          }
        />
      </div>
    </div>
  );
};

export default SelectHookFormMulti;
